import { EventEmitter as BaseEmitter } from 'events';

type EventMap = Record<string, any>;

type EventKey<T extends EventMap> = string & keyof T;
type EventReceiver<T> = (params: T) => void;

export interface Listener<T extends EventMap> {
    on<K extends EventKey<T>>(eventName: K, fn: EventReceiver<T[K]>): void;
    off<K extends EventKey<T>>(eventName: K, fn: EventReceiver<T[K]>): void;
}

export interface Emitter<T extends EventMap> {
    emit<K extends EventKey<T>>(eventName: K, params: T[K]): void;
}

export default class EventEmitter<T extends EventMap> implements Emitter<T>, Listener<T> {

    private readonly emitter: BaseEmitter;

    constructor() {
        this.emitter = new BaseEmitter();
    }

    removeAllListeners(): void {
        this.emitter.removeAllListeners();
    }

    on<K extends EventKey<T>>(eventName: K, fn: EventReceiver<T[K]>) {
        this.emitter.on(eventName, fn);
    }

    off<K extends EventKey<T>>(eventName: K, fn: EventReceiver<T[K]>) {
        this.emitter.off(eventName, fn);
    }

    emit<K extends EventKey<T>>(eventName: K, params: T[K]) {
        this.emitter.emit(eventName, params);
    }

}